(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const section = document.querySelector('.cards-section');
    const wrapper = section.querySelector('.cards-wrapper');
    const cards = document.querySelectorAll('.card');

    // Función para efecto de aparecer gradualmente cuando están en vista
    const fadeInObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });

    // Observar todas las tarjetas y sus imágenes para el efecto de fadeIn
    cards.forEach(card => {
      fadeInObserver.observe(card);
      const img = card.querySelector('.card-image');
      if (img) fadeInObserver.observe(img);
    });

    // Variables para el smooth scrolling
    let lastScrollTop = 0;
    let isScrolling = false;
    let scrollTimeout;
    let requestId;

    // Función para calcular el scroll horizontal
    function calculateHorizontalScroll() {
      const start = section.offsetTop;
      const end = start + section.offsetHeight - window.innerHeight;
      const width = wrapper.scrollWidth - window.innerWidth;
      
      const y = window.pageYOffset;
      
      // Si el scroll está en la parte superior o por encima, aseguramos que se muestre la primera tarjeta completa
      if (y <= start) {
        wrapper.scrollLeft = 0;
        return;
      }
      
      // Si el scroll está en la parte inferior o más allá, mostramos la última posición
      if (y >= end) {
        wrapper.scrollLeft = width;
        return;
      }
      
      // Cálculo normal para el progreso entre el inicio y el fin
      const progress = (y - start) / (end - start);
      wrapper.scrollLeft = width * progress;
    }

    // Función para el scroll con animación
    function smoothScroll() {
      calculateHorizontalScroll();
      requestId = null;
    }

    // Manejador de eventos de scroll con debounce y requestAnimationFrame
    window.addEventListener('scroll', function() {
      isScrolling = true;
      clearTimeout(scrollTimeout);
      
      // Usar requestAnimationFrame para sincronizar con la actualización del navegador
      if (!requestId) {
        requestId = window.requestAnimationFrame(smoothScroll);
      }
      
      // Detección de final del scroll
      scrollTimeout = setTimeout(function() {
        isScrolling = false;
        
        // Verificación especial para asegurar que la primera tarjeta esté bien posicionada
        const currentScrollY = window.pageYOffset;
        const start = section.offsetTop;
        
        // Si el scroll está cerca del inicio de la sección, ajustamos con precisión
        if (currentScrollY <= start + 10) {
          wrapper.scrollLeft = 0;
        }
      }, 150);
      
      // Guardar la última posición de scroll para saber la dirección
      lastScrollTop = window.pageYOffset;
    });

    // Asegurar posición correcta al cargar la página
    window.addEventListener('load', calculateHorizontalScroll);
    
    // También recalcular en resize para mantener la sincronización
    window.addEventListener('resize', calculateHorizontalScroll);

    // Observador para visibilidad de tarjetas durante el desplazamiento
    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const visibleCard = entry.target;
          visibleCard.classList.add('in-view');
        }
      });
    }, { 
      root: wrapper,
      rootMargin: '0px',
      threshold: 0.3 
    });
    
    cards.forEach(card => {
      visibilityObserver.observe(card);
    });

    // Ajustes para móviles
    if (isMobile) {
      // Añadir swipe manual para mejorar la experiencia móvil
      let touchStartX = 0;
      let touchEndX = 0;
      
      wrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      wrapper.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        // Si el usuario hace un swipe horizontal importante, actualizamos el scroll vertical
        // para mantener sincronizados ambos scrolls
        const swipeDistance = touchStartX - touchEndX;
        if (Math.abs(swipeDistance) > 50) {
          const start = section.offsetTop;
          const end = start + section.offsetHeight - window.innerHeight;
          const width = wrapper.scrollWidth - window.innerWidth;
          
          // Calcular el nuevo scroll vertical basado en la posición horizontal
          const newProgress = wrapper.scrollLeft / width;
          const newScrollY = start + newProgress * (end - start);
          
          // Scroll suave a la nueva posición
          window.scrollTo({
            top: newScrollY,
            behavior: 'smooth'
          });
        }
      }
      
      wrapper.addEventListener('touchmove', function(e) {
        // Permitir que el evento siga propagándose
      }, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-aromatherapy-anthropology"] && !Shopify.designMode) return;
  try {
    
const timeline = document.querySelector('[data-timeline="timeline"]');
const progress = document.querySelector('[data-parallax="color"]');
const items = document.querySelectorAll('.timeline-item');
const imgs = document.querySelectorAll('.item-side img');

// IntersectionObserver para animar imágenes al entrar en viewport
const io = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('active-viewport');
      io.unobserve(entry.target);
    }
  });
}, { threshold: 0.2 });
imgs.forEach(img => io.observe(img));

function handleScroll() {
  const scrollY = window.scrollY;
  const halfVh = window.innerHeight / 2;
  const lineTop = timeline.getBoundingClientRect().top + scrollY;

  if (scrollY >= lineTop - halfVh) {
    let height = scrollY - lineTop + halfVh;
    height = Math.min(height, timeline.scrollHeight);
    progress.style.height = `${height}px`;
  }

  const progressRect = progress.getBoundingClientRect();

  items.forEach(item => {
    const point = item.querySelector('.timeline-point');
    const textBlock = item.querySelector('.item-text');
    const imageBlock = item.querySelector('.item-image');
    const pointRect = point.getBoundingClientRect();
    const pointCenterY = pointRect.top + pointRect.height / 2;

    if (progressRect.bottom >= pointCenterY) {
      point.classList.add('active');
      // Cambiar el color de relleno a amarillo cuando está activo
      const pathElement = point.querySelector('path');
      if (pathElement) {
        pathElement.setAttribute('fill', '#000000');
      }
      textBlock.classList.add('active');
      imageBlock.classList.add('active');
    } else {
      point.classList.remove('active');
      // Restaurar el color de relleno a blanco cuando no está activo
      const pathElement = point.querySelector('path');
      if (pathElement) {
        pathElement.setAttribute('fill', 'white');
      }
      textBlock.classList.remove('active');
      imageBlock.classList.remove('active');
    }
  });
}

window.addEventListener('scroll', handleScroll);
window.addEventListener('load', () => { handleScroll(); imgs.forEach(img => io.observe(img)); });

  } catch(e) { console.error(e); }
})();
})();
